var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('span',{class:{ 'color-header': _vm.$utilFront.isDarkTheme(), 'color-sitd-dark': !_vm.$utilFront.isDarkTheme() }},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-icon',{attrs:{"medium":"","right":""}},[_vm._v(_vm._s(_vm.elementos.icono))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }